(function() {
  var __blocks__ = {};
  (function() {
    var element = document.getElementById("blocks-script");
    var attribute = a = element ? element.getAttribute("data-blocks") : '';
    var blocks = a.split(",").filter(Boolean);

    for (var i = 0; i < blocks.length; i++) {
      __blocks__[blocks[i]] = true;
    }
  })();
  (function() {
  if (!__blocks__["product-list-counter"] && !Shopify.designMode) return;
  try {
    (() => {
    const COUNTER_SELECTOR = '.product-list-counter-block__count[data-final-count]';

    /**
     * Syncs aside width from block setting to section CSS variable.
     * @param {HTMLElement} counterElement
     */
    const syncAsideWidth = (counterElement) => {
      const counterBlock = counterElement.closest('.product-list-counter-block');
      const aside = counterElement.closest('.section-resource-list__content--carousel-aside');

      if (!counterBlock || !aside) return;

      const asideWidth = counterBlock.dataset.carouselAsideWidth || 'auto';
      aside.style.setProperty('--carousel-aside-width', asideWidth);
    };

    /**
     * Animate a number from 0 to its final value.
     * @param {HTMLElement} counterElement
     */
    const setupCounterAnimation = (counterElement) => {
      if (counterElement.dataset.counterInit === 'true') return;
      counterElement.dataset.counterInit = 'true';

      const finalText = counterElement.textContent?.trim() || '0';
      const finalCount = Number.parseInt(counterElement.dataset.finalCount || '', 10);

      if (Number.isNaN(finalCount)) return;

      const prefersReducedMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;

      const animateCounter = () => {
        if (counterElement.dataset.counterAnimated === 'true') return;
        counterElement.dataset.counterAnimated = 'true';

        if (prefersReducedMotion || finalCount === 0) {
          counterElement.textContent = finalText;
          return;
        }

        const duration = 1200;
        const start = performance.now();
        counterElement.textContent = '0';

        const update = (now) => {
          const progress = Math.min((now - start) / duration, 1);
          const value = Math.round(progress * finalCount);
          counterElement.textContent = String(value);

          if (progress < 1) {
            requestAnimationFrame(update);
          } else {
            counterElement.textContent = finalText;
          }
        };

        requestAnimationFrame(update);
      };

      if (!('IntersectionObserver' in window)) {
        animateCounter();
        return;
      }

      const observer = new IntersectionObserver(
        (entries) => {
          const [entry] = entries;
          if (!entry?.isIntersecting) return;

          observer.unobserve(counterElement);
          animateCounter();
        },
        { threshold: 0.25 }
      );

      observer.observe(counterElement);
    };

    /**
     * @param {ParentNode} root
     */
    const initProductListCounters = (root = document) => {
      const counters = root.querySelectorAll(COUNTER_SELECTOR);
      counters.forEach((counter) => {
        syncAsideWidth(counter);
        setupCounterAnimation(counter);
      });
    };

    if (!window.__productListCounterInitBound) {
      window.__productListCounterInitBound = true;

      if (document.readyState === 'loading') {
        document.addEventListener('DOMContentLoaded', () => initProductListCounters(), { once: true });
      } else {
        initProductListCounters();
      }

      document.addEventListener('shopify:section:load', (event) => {
        if (!(event.target instanceof HTMLElement)) return;
        initProductListCounters(event.target);
      });

      document.addEventListener('shopify:block:select', (event) => {
        if (!(event.target instanceof HTMLElement)) return;
        initProductListCounters(event.target);
      });
    }

    initProductListCounters();
  })();
  } catch(e) { console.error(e); }
})();

})();
